import React, { useCallback } from "react"
import { StyleSheet, View } from "react-native"

import Base from "../../../../base"
import Collapsible from "../../../common/Collapsible"
import CategoryRow from "./CategoryRow"
import ItemRow from "./ItemRow"

export default function MenuCategory(props) {
  const renderHeader = useCallback(
    headerProps => (
      <CategoryRow
        item={props.category}
        static={props.static}
        onStatusChange={props.onStatusChange}
        {...headerProps}
      />
    ),
    [props],
  )

  return (
    <Collapsible RenderHeader={renderHeader}>
      <View style={styles.content}>
        {props.category.items.map((item, index) => (
          <ItemRow
            key={index}
            item={item}
            static={true}
            onPress={props.onPress}
            onStockChange={props.onStockChange}
            onStatusChange={props.onStatusChange}
            isFlooid={props.isFlooid}
          />
        ))}
        {(props.category.subCategories ?? []).map(category => (
          <MenuCategory
            key={category._id}
            category={category}
            onPress={props.onPress}
            onStockChange={props.onStockChange}
            onStatusChange={props.onStatusChange}
            isFlooid={props.isFlooid}
          />
        ))}
      </View>
    </Collapsible>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    height: 48,
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: Base.colours.appSemiLightGrey,
    borderBottomWidth: 1,
  },

  content: {
    marginLeft: 25,
  },
})
